import { BiCartAdd } from "react-icons/bi";
import { VscArrowSwap } from "react-icons/vsc";
import { LuDownload } from "react-icons/lu";
import { BsSend } from "react-icons/bs";
import CustomDialog from "@/components/ui/customDialog";
import DesktopDeposit from "@/components/auth/desktop/DesktopDeposit";
import DepositMethods from "@/components/deposit/DepositMethods";
import { useState } from "react";
import { useSession } from "@/contexts/LitSessionProvider";
import TokenToSend from "./TokenToSend";
import Link from "next/link";
import { AiFillBank } from "react-icons/ai";
export default function ActionsPortfolio() {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('card');
  const [isOpen, setIsOpen] = useState(false);
  function handleBack(type) {
    if (type === null) setSelectedPaymentMethod('card');
    setIsOpen(false);
  }
  const {
    PKP
  } = useSession();
  return <div className="genius-shadow p-3 gap-1 grid grid-cols-3 items-center bg-genius-indigo rounded-[20px] border-genius-blue border-[1px] ta-c justify-between" data-sentry-component="ActionsPortfolio" data-sentry-source-file="ActionsPortfolio.tsx">

            {/* <div
                onClick={() => setIsOpen(!isOpen)} className="cursor-pointer">
                <div className="flex items-center w-full h-[56px] bg-genius-blue bg-genius-blue rounded-[20px] justify-center">
                    <AiFillBank className="h-[20px] w-[20px]" />
                </div>
                <p className="text-[14px]">Cash Out</p>
             </div> */}
            <CustomDialog isOpen={isOpen} toggleModal={() => setIsOpen(!isOpen)} className={"h-fit w-[572px]"} data-sentry-element="CustomDialog" data-sentry-source-file="ActionsPortfolio.tsx">
                <DepositMethods selectedPaymentMethod={selectedPaymentMethod} setSelectedPaymentMethod={handleBack} PKP={PKP} data-sentry-element="DepositMethods" data-sentry-source-file="ActionsPortfolio.tsx" />
            </CustomDialog>

            <CustomDialog className={"h-fit w-[572px]"} trigger={<div className="cursor-pointer">
                <div className="flex items-center w-full h-[56px] bg-genius-blue rounded-[20px] justify-center">
                    <LuDownload className="h-[18px] w-[18px]" />
                </div>
                <p className="text-[14px]">Deposit</p>
            </div>} data-sentry-element="CustomDialog" data-sentry-source-file="ActionsPortfolio.tsx">
                <DesktopDeposit data-sentry-element="DesktopDeposit" data-sentry-source-file="ActionsPortfolio.tsx" />
            </CustomDialog>

            <CustomDialog className={"p-0 h-[522px] w-[572px]"} trigger={<div className="cursor-pointer">
                <div className="flex items-center w-full h-[56px] bg-genius-blue rounded-[20px] justify-center">
                    <BsSend className="h-[18px] w-[18px]" />
                </div>
                <p className="text-[14px]">Send</p>
            </div>} data-sentry-element="CustomDialog" data-sentry-source-file="ActionsPortfolio.tsx">
                <TokenToSend data-sentry-element="TokenToSend" data-sentry-source-file="ActionsPortfolio.tsx" />
            </CustomDialog>

            <Link href="/trade" data-sentry-element="Link" data-sentry-source-file="ActionsPortfolio.tsx">
                <div className="cursor-pointer">
                    <div className="flex items-center w-full h-[56px] bg-genius-blue rounded-[20px] justify-center">
                        <VscArrowSwap className="h-[18px] w-[18px]" data-sentry-element="VscArrowSwap" data-sentry-source-file="ActionsPortfolio.tsx" />
                    </div>
                    <p className="text-[14px]">Swap</p>
                </div>
            </Link>
        </div>;
}